import axiosInstance from "auth/FetchInterceptor";
import { DC_GET_CONFIGS, DC_SAVE_CONFIGS, DC_RESTORE_DEFAULTS, DC_PREVIEW } from "constants/ApiConstant";
const DocumentCodeService = {};

DocumentCodeService.getDCConfigs = function () {
  return axiosInstance.get(DC_GET_CONFIGS, null);
};

DocumentCodeService.saveDCConfigs = function (data) {
  return axiosInstance.post(DC_SAVE_CONFIGS, data);
};

DocumentCodeService.restoreDCDefaults = function () {
  return axiosInstance.post(DC_RESTORE_DEFAULTS, null);
};

DocumentCodeService.getDCPreview = function (data) {
  return axiosInstance.post(DC_PREVIEW, data);
};

export default DocumentCodeService;
